import { render, staticRenderFns } from "./BuildOrder.vue?vue&type=template&id=55ad9712&"
import script from "./BuildOrder.vue?vue&type=script&lang=js&"
export * from "./BuildOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports